// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { controlsContainerStyles } from "@awc/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { PLP_BREAKPOINT } from "@awc/XDL/constants";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

controlsContainerStyles.shadowBox = {
    container: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            gap: 16px 24px;
            ${xScreen("lt", PLP_BREAKPOINT)} {
                & .hide-on-mobile {
                    display: none;
                }
            }
            .pagination-page-number {
                margin-left: auto;
            }
            .pagination-sort-by {
                ${xScreen("lte", "sm")} {
                    width: 100%;
                }
            }
        `,
    },
};

controlsContainerStyles.container = {
    css: css`  
        min-height: 27px;
        ${xScreen("lte", "sm")} {
            min-height: 114px;
        }
    `,
}
